/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getLogLevelFromName.ts
 */

import {
  LOG_LEVEL_NONE_NAME,
  LOG_LEVEL_NONE,
  LOG_LEVEL_DEBUG_NAME,
  LOG_LEVEL_DEBUG,
  LOG_LEVEL_LOG_NAME,
  LOG_LEVEL_LOG,
  LOG_LEVEL_INFO_NAME,
  LOG_LEVEL_INFO,
  LOG_LEVEL_WARN_NAME,
  LOG_LEVEL_WARN,
  LOG_LEVEL_ERROR_NAME,
  LOG_LEVEL_ERROR,
  LOG_LEVEL_CRITICAL_NAME,
  LOG_LEVEL_CRITICAL,
} from '../constants'

export interface NameToLogLevelMap {
  [LOG_LEVEL_NONE_NAME]: typeof LOG_LEVEL_NONE
  [LOG_LEVEL_DEBUG_NAME]: typeof LOG_LEVEL_DEBUG
  [LOG_LEVEL_LOG_NAME]: typeof LOG_LEVEL_LOG
  [LOG_LEVEL_INFO_NAME]: typeof LOG_LEVEL_INFO
  [LOG_LEVEL_WARN_NAME]: typeof LOG_LEVEL_WARN
  [LOG_LEVEL_ERROR_NAME]: typeof LOG_LEVEL_ERROR
  [LOG_LEVEL_CRITICAL_NAME]: typeof LOG_LEVEL_CRITICAL
}

export const nameToLogLevelMap: NameToLogLevelMap = {
  [LOG_LEVEL_NONE_NAME]: LOG_LEVEL_NONE,
  [LOG_LEVEL_DEBUG_NAME]: LOG_LEVEL_DEBUG,
  [LOG_LEVEL_LOG_NAME]: LOG_LEVEL_LOG,
  [LOG_LEVEL_INFO_NAME]: LOG_LEVEL_INFO,
  [LOG_LEVEL_WARN_NAME]: LOG_LEVEL_WARN,
  [LOG_LEVEL_ERROR_NAME]: LOG_LEVEL_ERROR,
  [LOG_LEVEL_CRITICAL_NAME]: LOG_LEVEL_CRITICAL,
}

export type LogLevelName = keyof NameToLogLevelMap

const names = new Set(Object.keys(nameToLogLevelMap))

export const isLogLevelName = (name: any): name is LogLevelName =>
  names.has(name)

export const getLogLevelFromName = (name: any) => {
  // NOTE: Rollbar uses "warning" instead of "warn"
  if (name === 'warning') {
    name = LOG_LEVEL_WARN_NAME
  }
  if (isLogLevelName(name)) {
    return nameToLogLevelMap[name]
  }
}
